import { SelloutProductColor } from '../../../../../../../../../../services/modules/product-color-sellout/product-color-sellout.types';
import {
  CalculateDistributionParams,
  SelloutDistribution,
} from '../types/selloutDistribution.types';

export const getSelloutPiecesDistribution = (
  selloutProductColor: SelloutProductColor,
  piecesToDistribute: number,
): SelloutDistribution[] => {
  if (selloutProductColor.totalSold === 0) {
    return selloutProductColor.skus.map((sku) => ({
      skuId: sku.id,
      quantityToDistribute: 0,
    }));
  }

  const rawDistribution = selloutProductColor.skus.map((sku) =>
    calculateDistribution({
      piecesToDistribute,
      sizeQuantitySold: sku.sold,
      totalQuantitySold: selloutProductColor.totalSold,
    }),
  );

  const integerDistribution = rawDistribution.map(Math.floor);
  const distributedSum = integerDistribution.reduce((sum, current) => sum + current, 0);
  const difference = piecesToDistribute - distributedSum;

  const remainders = rawDistribution
    .map((value, index) => ({
      index,
      remainder: value - integerDistribution[index],
    }))
    .sort((a, b) => b.remainder - a.remainder);

  for (let i = 0; i < difference; i++) {
    integerDistribution[remainders[i]?.index]++;
  }

  return selloutProductColor.skus.map((sku, index) => ({
    quantityToDistribute: integerDistribution[index],
    skuId: sku.id,
  }));
};

export const calculateDistribution = ({
  piecesToDistribute,
  sizeQuantitySold,
  totalQuantitySold = 0,
}: CalculateDistributionParams) => {
  if (!totalQuantitySold) {
    return 0;
  }

  return (piecesToDistribute * sizeQuantitySold) / totalQuantitySold;
};
